import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

import Swiper from 'swiper/bundle'; // import Swiper JS ALL

/*
 * Common
*/

// Single
const postSwiper = new Swiper('.post-swiper', {
  slidesPerView: 1,
  spaceBetween: 18,
  centeredSlides: false,
  /*
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  */
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 48,
      initialSlide: 1,
      centeredSlides: true,
    }
  }
});

// Hero
const heroSwiper = new Swiper('.hero-swiper', {
  // loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: 5000, // 5秒ごとに切り替え
    disableOnInteraction: false, // ユーザー操作後も自動再生を継続
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
});


/*
 * Single product
 */
$(function() {
  /*
  //swiper 768以下で起動
  var swiper;
  $(window).on('load resize', function(){
    var w = $(window).width();
    if (w <= 767.98) {
      if (swiper) {
        return;
      } else {
        swiper = new Swiper('#single-product-gallery', {
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
      }
    } else {
      if (swiper) {
        swiper.destroy();
        swiper = undefined;
      }
    }
  });
  */
});

const SingleProductSubgallerySwiper = new Swiper('#single-product-subgallery', {
  slidesPerView: "auto",
  spaceBetween: 18,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    991: {
      slidesPerView: "auto",
      spaceBetween: 48,
    }
  }
});

/*
 * select2 - variable product
 */
 /*
import select2 from "select2";

function formatColor (color) {
  if (!color.id) {
    return color.text;
  }
  var classname = color.element.value.toLowerCase().replace(/[^0-9a-z]/gi, '');
  var $color = $(
    '<span class="icon icon-' + classname.split(' ').join('') + '">' + color.text + '</span>'
  );
  // var baseUrl = "../img/color/";
  // var $color = $(
  //   '<span><img src="' + baseUrl + color.element.value.toLowerCase() + '.jpg" class="img-color" /> ' + color.text + '</span>'
  // );
  return $color;
};

$(document).ready(function() {
	$('select#color, select#belt-color').select2({
		minimumResultsForSearch: -1,
		templateResult: formatColor
	});
	$('select#size').select2({
		minimumResultsForSearch: -1,
	});
});
*/
